export default __webpack_public_path__ + "static/media/10.8d1372b3.png";